import { AppShell, TabbarContainer } from "@app/ui";
import { i18nInit } from "@fanfanlo";
import { Box } from "@mui/material";
import { OpenA11yNodeButton } from "@src/components/a11y/open-a11y-node-button";
import { TestA11y } from "@src/components/a11y/test-a11y";
import { AndroidFloatWindowLink } from "@src/components/android-float/window/AndroidFloatWindowLink";
import { AndroidSettingsInfo } from "@src/components/android-settings/AndroidSettingsInfo";
import { KillSelf } from "@src/components/app/kill-self/KillSelf";
import { AddExternalMarketButton } from "@src/components/markets/AddExternalMarketButton";
import { MainPageAddButtons } from "@src/components/markets/main-page-add-buttons/MainPageAddButtons";
import { NavBar } from "@src/components/navbar/NavBar";
import { NotificationListenerPanel } from "@src/components/notification-listener/NotificationListenerPanel";
import { HomeContent } from "@src/components/page/home/HomeContent";
import { MarketsDevSettingsLineOpenLinkButton } from "@src/components/page/markets-dev-settings/open-link-button/OpenLinkButton";
import { TextRecognitionControl } from "@src/components/screen-recognition/TextRecognitionControl";
import { marketsScriptManager } from "@src/markets/markets-script-manager";
import { useEffect, useState } from "react";
import { HomePagePermissions } from "../../components/permissions/home-page-permissions/HomePagePermissions";
import { TestScript } from "./test-script";

i18nInit()
export default function Home() {
   
    return (
        <AppShell>
            <TabbarContainer titleConf={{ ns: "homepage/pages/home/content", key: "home.title" }}
                        navBar={<NavBar/>}>
                            <HomeContent />
                {/* <Content /> */}
            </TabbarContainer>
        </AppShell>
    )
}



function test() {
    const s = `var script1=function(n){"use strict";return function(){function v(){return new Date().getTime()}var u={exports:{}},e={};/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */var c=Symbol.for("react.transitional.element"),d=Symbol.for("react.fragment");function s(T,t,r){var i=null;if(r!==void 0&&(i=""+r),t.key!==void 0&&(i=""+t.key),"key"in t){r={};for(var o in t)o!=="key"&&(r[o]=t[o])}else r=t;return t=r.ref,{$$typeof:c,type:T,key:i,ref:t!==void 0?t:null,props:r}}e.Fragment=d,e.jsx=s,e.jsxs=s,u.exports=e;var l=u.exports;function a(){return l.jsx("div",{children:l.jsx("button",{children:"html生成的按钮"})})}const x={UI:a};function E(){return v()}n.components=x,n.printA=E,Object.defineProperty(n,Symbol.toStringTag,{value:"Module"})}(),n}({}); return script1;`
    const o = new Function(s)()
    o.printA();
    // console.log('cccccccccccccccomponents=', o.components)
    return o;
}

function Content() {
    const [ui, setUI] = useState(null)
    useEffect(() => {
        if (typeof window !== 'undefined') {
            // console.log('has window', document.domain);
            // document.domain = window.location.hostname;
            // console.log('domain is', document.domain);
            ; (window as any).sayHello = function (msg: string) {
                alert('child' + msg)
            }
            console.log('window say=', (window as any).sayHello)
        }
        setTimeout(() => {
            setUI(test().components.UI())
        }, 1000 * 5)
    }, [])

    useEffect(() => {
        marketsScriptManager.init();
    }, []);
    return (
        <Box >
            {/* <ProjectIFrame /> */}
            {/* <MeetingRoom roomName="test-room" userName={`user-${Math.random().toString(36).substring(2, 8)}`} />  */}

            {/* <IMOpenPageLink /> */}
            {/* <SendSms /> */}
            <AndroidSettingsInfo />
            {/* <SmsScriptItemComponent /> */}
            {/* 添加外部市场 */}
            <AddExternalMarketButton />
            {/* {o.components.UI()} */}
            {/* html生成的按钮 */}
            {/* {ui} */}
            <HomePagePermissions />
            <NotificationListenerPanel />

            {/* <QiyeWeixinTestButton /> */}

            {/* <MobileAlbumPanel /> */}
            <TestA11y />
            <AndroidFloatWindowLink />
            {/* <TestWindowConfUI2 /> */}
            {/* <IFrameReactContainer url="/scripts/fanfanlo/scripts/emergency-alarm/index.js" urlAsContent={true} htmlBuilder={marketHtmlUtils.createHtml} /> */}
            {/* <IFrameReactContainer url="/scripts/fanfanlo/scripts/emergency-alarm/index.js" urlAsContent={true} htmlBuilder={marketHtmlUtils.createHtml} /> */}
            {/* <IFrameReactContainer url="/scripts/fanfanlo/scripts/emergency-alarm/index.js" urlAsContent={true} htmlBuilder={marketHtmlUtils.createHtml} />
            <IFrameReactContainer url="/scripts/fanfanlo/scripts/emergency-alarm/index.js" urlAsContent={true} htmlBuilder={marketHtmlUtils.createHtml} />
            <IFrameReactContainer url="/scripts/fanfanlo/scripts/emergency-alarm/index.js" urlAsContent={true} htmlBuilder={marketHtmlUtils.createHtml} />
            <IFrameReactContainer url="/scripts/fanfanlo/scripts/emergency-alarm/index.js" urlAsContent={true} htmlBuilder={marketHtmlUtils.createHtml} />
            <IFrameReactContainer url="/scripts/fanfanlo/scripts/emergency-alarm/index.js" urlAsContent={true} htmlBuilder={marketHtmlUtils.createHtml} />
            <IFrameReactContainer url="/scripts/fanfanlo/scripts/emergency-alarm/index.js" urlAsContent={true} htmlBuilder={marketHtmlUtils.createHtml} /> */}

            {/* <IframeResizer offsetSize={3} bodyMargin="0px" bodyPadding="0px" style={{width:'100%'}}
            src="http://192.168.177.180:3000/tools-test/webview-version.html" /> */}

            {/* <IframeResizer offsetSize={3} bodyMargin="0px" bodyPadding="0px" style={{width:'100%'}}
            src="https://baidu.com" /> */}
            {/* 节点信息按钮 */}
            <Box>
                <OpenA11yNodeButton />
            </Box>
            <TextRecognitionControl />
            {/* 这个代码的调用的外部script文件没找到 */}
            <TestScript />
            <Box>
                <KillSelf />
            </Box>
            <MarketsDevSettingsLineOpenLinkButton />    
            <MainPageAddButtons />
            {/* <IFrameReactContainer url="http://192.168.177.180:5173/pages/accessibility-pn-an-info/#" /> */}
            {/* <IFrameReactContainer url="http://192.168.177.180:5173/pages/market1/" /> */}

            {/* <div>isInAndroid:{isInAndroid().toString()}</div>
            <div>count:{count}</div> */}
            <div>
            </div>
        </Box>

    )
}

